// =============================================================================
// SubjectCalibrationDeck — the subject-line counterpart to CalibrationDeck.
//
// Same Tinder-style swipe UX, only it generates candidate SUBJECT LINES (per
// open-worthy tactic) and persists to clone.subjectCalibration. All the deck
// mechanics live in CalibrationDeck; this is just the "subject" variant so the
// two decks stay a single source of truth.
// =============================================================================

import React from "react";
import CalibrationDeck from "./CalibrationDeck";

const SubjectCalibrationDeck = ({ userId, cloneId, clone }) => (
  <CalibrationDeck userId={userId} cloneId={cloneId} clone={clone} variant="subject" />
);

export default SubjectCalibrationDeck;
